import React, { useEffect } from 'react'
import { Box, Typography, Container } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import AOS from 'aos';
import Preloader from '../../../common/Preloader'; 
import 'swiper/css';
import 'swiper/css/navigation';

const AlliancesSection = ({data}) => {

  useEffect(() => { AOS.init({ duration: 800, offset: 100 }); }, []);

  if (!data) { return ( <Preloader />  ); }

  const { title = "Alianzas", images = []  } = data || {};
  
  return (
    <Box id="partners" sx={{ py: 8, textAlign: 'center', backgroundColor: '#fff' }} >
      <Container maxWidth="lg">
        <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 4, color: 'primary.main' }} data-aos="fade-up">
          {title}
        </Typography>
        <Box sx={{ position: 'relative', mx: 'auto', }} data-aos="fade-up">
          <Swiper
            modules={[Navigation]}
            spaceBetween={16}
            slidesPerView={1}
            navigation={true}
            breakpoints={{
              640: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
            }}
          >
            <>
              {images.length > 0 ? (
                images.map((image, index) => {
                  const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:1337";
                  const imageUrl = image?.url  ? `${baseUrl}${image.url}`   : ""; 
                  return (
                    <SwiperSlide key={index}>
                      <Box className="card-alliance">
                        <Box 
                          component="img" 
                          src={imageUrl} // URL completa de la imagen
                          alt={image.alternativeText || 'Imagen'} // Texto alternativo si está disponible
                          sx={{ width: '80%', height: 'auto', mb: 2 }}
                        />
                      </Box>
                    </SwiperSlide>
                  );
                })
              ) : (<Typography variant="body1" sx={{ color: "text.secondary" }}>
                No hay imágenes para mostrar en este momento.
              </Typography>)}
            </>

          </Swiper>
        </Box>
      </Container>
    </Box>
  );
};

export default AlliancesSection;
